import { Box, DialogContent, DialogTitle } from "@mui/material";
import { PTTypography } from "../../../common/components/ui";
import CreateAccountDialog from "../../frontOffice/createAccount/page/CreateAccountDialog";

export const InscriptionDialogContent = (props) => {
  const {
    title,
    description,
    open,
    actions = [],
    onConfirm,
    onCancel,
    onClose,
    dialogStyle,
    descriptionStyle,
    titleStyle,
    ...otherProps
  } = props;
  return (
    <>
      <DialogTitle sx={{ ...(titleStyle || {}) }}>
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <PTTypography
            variant="h6"
            component="h1"
            sx={{
              fontWeight: "bold",
              fontSize: "17.84px",
              color: "#232A56",
            }}
          >
            registration.title
          </PTTypography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pl: 5, pr: 5, pb: 4 }}>
        <CreateAccountDialog />
      </DialogContent>
    </>
  );
};

export default InscriptionDialogContent;
